<template>
    <div class=" d-flex flex-lg-row flex-column w-100 gap-md">
        <div class="agenda">
			<a class="mb-5 btn btn-dark" target="_blank" :href="isProd ? 'https://admin.clinicaprimeseg.com.br/agendamento/chamado': 'http://localhost:8080/agendamento/chamado'">Abrir Sala De Chamados</a>
            <b-form class="d-flex flex-column gap-md w-100">
                <b-form-row>
                    <b-calendar @input="consultarAgenda" class="mx-auto" v-model="dataSelecionada" locale="pt-br" label-no-date-selected="Nenhuma Data Selecionada" label-selected="Data Selecionada" label-help></b-calendar>
                </b-form-row>
                <b-form-row>
                    <div class="w-100 d-flex flex-column gap-sm">
                        <h6>Filtros:</h6>
                        <div class="d-flex justify-content-center align-items-center gap-sm">
                            <label for="periodo">Período:</label>
                            <select v-model="periodo" name="periodo" id="periodo" class="form-control w-100">
                                <option selected disabled value>Selecione</option>
                                <option value="Manhã">Manhã</option>
                                <option value="Tarde">Tarde</option>
                            </select>
                        </div>
                        <div class="d-flex flex-column gap-sm w-100">
                            <label>Agenda:</label>
                            <div class="d-flex gap-sm w-100 justify-content-start flex-wrap">
                                <div class="d-flex align-items-center gap-sm" v-for="(s, index) in salasExame" :key="index">
									<b-form-checkbox
      								v-model="s.ativo"
      								@input="setaFieldsTable">
      								{{ s.sala }}
    								</b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form-row>
            </b-form>
        </div>
        <div class="tabela">
            <b-table  sticky-header head-variant="light" bordered :items="items" :fields="fields" responsive style="max-height: 90vh !important;" :busy="carregando">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
				<template #cell(audiometria)="data">
					<p v-if="data.item.audiometria != null" @click="abrirModalRealizarChamado(data.item.audiometria)" :class="selecionaCorSituacaoAgendamento(data.item.audiometria.situacao, data.item.audiometria.foiChamado)">
						{{ data.item.audiometria.funcionario }}
					</p>
				</template>
				<template #cell(laboratorio)="data">
					<p v-if="data.item.laboratorio != null" @click="abrirModalRealizarChamado(data.item.laboratorio)" :class="selecionaCorSituacaoAgendamento(data.item.laboratorio.situacao, data.item.laboratorio.foiChamado)">
						{{ data.item.laboratorio.funcionario }}
					</p>
				</template>
				<template #cell(triagem)="data">
					<p v-if="data.item.triagem != null"  @click="abrirModalRealizarChamado(data.item.triagem)" :class="selecionaCorSituacaoAgendamento(data.item.triagem.situacao, data.item.triagem.foiChamado)">
						{{data.item.triagem.funcionario }}
					</p>
				</template>
				<template #cell(consultorio)="data">
					<p v-if="data.item.consultorio != null" @click="abrirModalRealizarChamado(data.item.consultorio)"  :class="selecionaCorSituacaoAgendamento(data.item.consultorio.situacao, data.item.consultorio.foiChamado)">
						{{ data.item.consultorio.funcionario }}
					</p>
				</template>
				<template #cell(complementares)="data">
					<p v-if="data.item.complementares != null" @click="abrirModalRealizarChamado(data.item.complementares)" :class="selecionaCorSituacaoAgendamento(data.item.complementares.situacao, data.item.complementares.foiChamado)">
						{{ data.item.complementares.funcionario }}
					</p>
				</template>
			</b-table>
			<modalRealizarChamado ref="modalRealizarChamado" @chamadoConfirmado="handleChamadoConfirmado" @agendamentoCancelado="handleAgendamentoCancelado" @exameCancelado="handleExameCancelado"/>

        </div>
    </div>
</template>

<script>
import SalaExameService from "../../service/SalaExameService.js";
import AgendamentoService from "../../service/AgendamentoService.js";
import ModalRealizarChamado from "./ModalRealizarChamado.vue";

export default{
	name: "Agenda",
	components: {
		modalRealizarChamado: ModalRealizarChamado,
	},
	data() {
		return {
			carregando: false,
			salasExame: [],
			items: [],
			fields: [
				{
					label: "",
					key: "horario",
					variant: "secondary",
				},
			],

			dataSelecionada: new Date(),

			mostrarTable: false,
			periodo: "Manhã",

			isProd: false,
		};
	},
	created() {
		if (process.env.NODE_ENV == "production") {
			this.isProd = true;
		}
		this.inicializarValores();
	},
	watch: {
		periodo() {
			this.consultarAgenda();
		},
	},
	methods: {
		handleExameCancelado() {
			this.inicializarValores();
		},
		handleAgendamentoCancelado(idAgendamento) {
			this.mensagem("Agendamento Cancelado Com Sucesso!", "Sucesso", "success");
			this.$refs.modalRealizarChamado.fecharModal(idAgendamento);
			this.inicializarValores();
		},
		handleChamadoConfirmado() {
			this.inicializarValores();
		},
		inicializarValores() {
			this.listarSalasExames();
			this.consultarAgenda();
		},
		abrirModalRealizarChamado(agendamento) {
			this.$refs.modalRealizarChamado.abrirModal(agendamento);
		},
		selecionaCorSituacaoAgendamento(situacao, foiChamado) {
			if (!foiChamado) {
				switch (situacao) {
				case "Agendado":
					return "statusAguardandoSerChamado";

				case "Cancelado":
					return "statusAgendamentoCancelado";
				default:
					return "";
				}
			} else {
				return "statusChamadoRealizado";
			}
		},
		setaFieldsTable() {
			this.fields = [
				{
					label: "",
					key: "horario",
					variant: "secondary",
				},
			];
			this.salasExame.forEach((e) => {
				if (e.ativo) {
					this.fields.push(
						{
							label: e.sala,
							key: e.referencia,
							variant: "light",
						},
					);
				}
			});
		},
		listarSalasExames() {
			SalaExameService.consultar()
				.then((res) => {
					this.salasExame = res.data;
					this.salasExame.forEach((e) => {
						e.ativo = true;
					});
					this.setaFieldsTable();
				}).catch((err) => {
					console.log(err);
				});
		},
		consultarAgenda() {
			this.carregando = true;
			const dia = this.$options.filters.moment(this.dataSelecionada).format("DD/MM/YYYY");
			AgendamentoService.consultarAgenda(this.periodo, dia)
				.then((res) => {
					this.items = res.data;
				}).catch((err) => {
					console.log(err);
				}).finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};

</script>
<style scoped>
.agenda {
    width: 25%;
}
.tabela{
    width: 75%;
}
@media screen and (max-width: 968px) {
    .agenda{
        width: 100% !important;
    }
    .tabela{
        width: 100% !important;
    }
}
.statusChamadoRealizado{
	color: rgb(67, 196, 16) !important;
	cursor: pointer !important;
}
.statusAguardandoSerChamado{
	color: rgb(216, 198, 36) !important;
	cursor: pointer !important;
}
.statusAgendamentoCancelado{
	color: rgb(172, 41, 41) !important;
	cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Agendamento/Agenda.vue